module.exports = __webpack_public_path__ + "static/title-5a243f4e84777fa6ff99f1b7cd8072d7.svg";